<ng-container *ngIf="mainImage$ | async as main; else noMedia">
  <cx-media [container]="main"> </cx-media>
  <ssab-cx-add-to-wishlist [product]="product"></ssab-cx-add-to-wishlist>
</ng-container>

<ng-template #noMedia>
  <cx-media  class="is-initialized is-missing"></cx-media>
  <ssab-cx-add-to-wishlist [product]="product"></ssab-cx-add-to-wishlist>
</ng-template>
